import FileUpload from './ui/fileUpload';

export default FileUpload;